module.exports = __webpack_public_path__ + "img/btn_LOW_win.5391ecd7.png";